import React from 'react';
import { Box } from '@material-ui/core';
import Spinner from '../Loader/Spinner';
// Overlay takes all the available space in container with position: relative
function LoadingOverlay(props) {
    return (React.createElement(Box, { position: "absolute", display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%", zIndex: 10, ...props },
        React.createElement(Spinner, { color: "primary" })));
}
export default LoadingOverlay;
